import { render, staticRenderFns } from "./industryForm.vue?vue&type=template&id=3f156144&scoped=true&"
import script from "./industryForm.vue?vue&type=script&lang=js&"
export * from "./industryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f156144",
  null
  
)

export default component.exports